export default __webpack_public_path__ + "static/media/icons8-sand-timer.ff8ea97c.svg";